var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-billings-overview" },
    [
      _c(
        "Panel",
        [
          _c("h2", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v(_vm._s(_vm._f("trans")("titles.invoices")))
          ]),
          _vm._v(" "),
          _c("Invoices")
        ],
        1
      ),
      _vm._v(" "),
      _c("router-view", { attrs: { current: _vm.current, plans: _vm.plans } }),
      _vm._v(" "),
      _vm.loading ? _c("Loading", { staticClass: "absolute" }) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ba5a0a62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba5a0a62","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/sections/general/InvoiceDetail.vue
// module id = null
// module chunks = 